import {ReactNode, useState} from "react";

import {Box, Dialog, DialogContent, DialogTitle, Stack, Typography,} from "@mui/material";
import {ConfirmDialog, ConfirmDialogContext, SetConfirmDialogContext} from "@/hooks/use-confirm-dialog";

export function ConfirmDialogProvider({children}: { children: ReactNode }) {
  const [dialog, setDialog] = useState<ConfirmDialog | undefined>(undefined);
  
  return (
    <ConfirmDialogContext.Provider value={dialog}>
      <SetConfirmDialogContext.Provider value={setDialog}>
        {dialog && (
          <Dialog
            open={true}
            onClose={dialog.onClose}
            fullScreen={dialog.fullScreen}
            fullWidth={dialog.fullWidth}
            maxWidth={dialog.maxWidth ?? "sm"}
            PaperProps={
              dialog.fullWidth
                ? {style: {margin: 0, width: "100%"}}
                : undefined
            }
          >
            {dialog.title && (
              <DialogTitle
                sx={{backgroundColor: "primary.main", ...dialog.titleSx}}
              >
                {dialog.title}
              </DialogTitle>
            )}
            <DialogContent>
              <Stack spacing={2}>
                {dialog.icon && (
                  <Box sx={{display: "flex", justifyContent: "center"}}>
                    {dialog.icon}
                  </Box>
                )}
                {dialog.message && (
                  <Typography textAlign={"center"}>{dialog.message}</Typography>
                )}
                {dialog.children}
              </Stack>
            </DialogContent>
          </Dialog>
        )}
        {children}
      </SetConfirmDialogContext.Provider>
    </ConfirmDialogContext.Provider>
  );
}
